<!--
  Two child dialogs — only one is visible at a time:
   1. Parent-task confirm (shown when the task being deleted has dependent tasks).
      Mirrors the modal that already exists in edit-task-modal.component.html so
      the visual treatment matches what users see when deleting from there.
   2. Standard vf-delete-popup (shown when there are no dependents). Reuses the
      same shared component every other task surface in the app uses.
-->

<!-- Parent-task confirm modal — identical markup/style to the one in edit-task-modal.
     The `vf-task-delete-confirm-modal` class lets style.css override the
     `.task-slider .modal-dialog` full-screen rule when this dialog is rendered
     deep inside the task slider (e.g. from the dependencies tab). -->
<div bsModal #parentConfirmModal="bs-modal"
  class="modal fade center-modal trovve-sm-modal z-index-1110 vf-task-delete-confirm-modal"
  tabindex="-1"
  [config]="{ backdrop: 'static', keyboard: false }">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mw-490">
    <div class="modal-content login-modal box-shadow-popup border-all" style="background: #ffffff !important;">
      <button type="button" aria-label="Close" (click)="onCloseParentConfirm()"
        class="btn p-0 d-flex align-items-center justify-content-center text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-sm transition-colors"
        style="position: absolute; top: 16px; right: 16px; width: 28px; height: 28px; z-index: 1;">
        <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
      </button>
      <div class="modal-body text-center pb-4 mt-20" style="background: #ffffff !important;">
        <div class="py-2">
          <ibm-icon-trash-can size="20" class="rounded-circle border p-10"></ibm-icon-trash-can>
        </div>
        <h1 class="f-size-20 tk-montserrat text-vf-dark font-weight-semibold mb-10 mt-20">
          You're about to delete a parent task.
        </h1>
        <p class="f-size-14 text-medium font-weight-normal mb-0">
          What would you like to do with its dependent tasks?
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-end align-items-center border-0"
        style="gap: 8px; padding: 16px 0 0 0; background: #ffffff !important;">
        <button type="button" style="min-width: 80px;"
          class="btn f-size-14 text-gray-700 rounded-8 py-10 hover:bg-gray-100 transition-colors border-0 bg-transparent m-0 line-height-16"
          (click)="onDeleteAll()">Delete all
        </button>
        <button type="button" style="min-width: 80px;"
          class="btn btn-black f-size-14 rounded-8 py-10 m-0 line-height-16"
          (click)="onKeepTasks()">Keep tasks
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Standard delete popup (no dependents) -->
<vf-delete-popup
  [entity]="'Task'"
  [isOpenFromSlider]="isOpenFromSlider"
  [entityObj]="regularDeleteTarget"
  (okClick)="onRegularDelete($event)">
</vf-delete-popup>
